import { useCallback, useMemo, useState } from "react";
import api from "../../utils/api";
import { FormLabel, Grid, MenuItem, Select } from "@mui/material";
import { StringNumber } from "../../types";

export const SelectCargoGrupo = ({ action, valor: _val }: { action: any, valor?: StringNumber | null }) => {

  const [grupos, setGrupos] = useState<{id: number, descricao: string }[]>();


  const getGrupos = async () => {
    try {
      const req = await api.get('ministerio/cargo/grupo');
      const res = req?.data;

      setGrupos(res);
    } catch (error) {

    }
  }

  useMemo(() => {
    getGrupos()
  }, [])

  const Selecter = useCallback(() => {
    return (
      <Select
      value={_val}
      onChange={action}
    >
      {
        grupos?.map(
          ministerio =>
            <MenuItem value={ministerio?.id}>
              {ministerio?.descricao}
            </MenuItem>
        )
      }
    </Select>
    )

  }, [grupos, _val])

  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>Grupos</FormLabel>
        {
          grupos && (
            <Selecter/>
          )
        }
      </Grid>
    </>
  )
}
